/* eslint-disable react-hooks/rules-of-hooks */
import * as React from 'react';
import { useSelector } from 'react-redux';
import {
  selectEstimationTarget,
  selectsRedirectLink,
  selectFormFields,
  selectIsFormWithRoomNumberExperiment,
} from '../../../selectors';
import { EMyHomeEstimationTargets } from '../../../types/estimationTarget';
import { useActions, useSubmitAnalyticsFieldsWithRoomNumber } from '../../../hooks';
import { trackAddNewCard } from '../../../hooks/tracking';
import { TApplicationState } from '../../../types/redux';
import { navigateToPage } from '@cian/valuation-utils-component';

export const useSubmitClickHandler = () => {
  const estimationTarget = useSelector(selectEstimationTarget);
  const redirectLink = useSelector(selectsRedirectLink);
  const filters = useSelector(selectFormFields);
  const withRoomNumber = useSelector(selectIsFormWithRoomNumberExperiment);

  const isFormValid = useSelector((state: TApplicationState) => state.submitForm.isFormValid);

  const trackMyHomeWithFlatNumberAnalytics = () => useSubmitAnalyticsFieldsWithRoomNumber(filters, true);

  const {
    submitFlatData,
    submitSuburbanData,
    deleteErrorMessage,
    validateFlatFormFields,
    validateHouseFormFilters,
    validateLandFormFilters,
  } = useActions();
  const isSuburban = [EMyHomeEstimationTargets.house, EMyHomeEstimationTargets.land].includes(estimationTarget);
  const submitAction = isSuburban ? submitSuburbanData : submitFlatData;

  React.useEffect(() => {
    if (isFormValid) {
      submitAction();
    }
  }, [isFormValid]);

  React.useEffect(() => {
    if (redirectLink) {
      navigateToPage(redirectLink);
    }
  }, [redirectLink]);

  return React.useCallback(() => {
    if (withRoomNumber && estimationTarget === EMyHomeEstimationTargets.flat) {
      trackMyHomeWithFlatNumberAnalytics();
    } else {
      trackAddNewCard(estimationTarget);
    }
    deleteErrorMessage();

    if (estimationTarget === EMyHomeEstimationTargets.flat) {
      validateFlatFormFields();

      return;
    }

    if (estimationTarget === EMyHomeEstimationTargets.house) {
      validateHouseFormFilters();

      return;
    }

    if (estimationTarget === EMyHomeEstimationTargets.land) {
      validateLandFormFilters();

      return;
    }

    return;
  }, [estimationTarget]);
};
